module.exports = __webpack_public_path__ + "static/media/plus-circle.d4547011.svg";